import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-sorder/starorder/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const getOrderInfo = (id) => {
    return request({
        url: '/api/blade-sorder/starorder/detail/' + id,
        method: 'get'
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-sorder/starorder/perfect',
        method: 'post',
        data: row
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-sorder/starorder/save',
        method: 'post',
        data: row
    })
}


// export const getDetail = (id) => {
//     return request({
//         url: '/api/blade-order/order/detail',
//         method: 'get',
//         params: {
//             id
//         }
//     })
// }


export const remove = (ids) => {
    return request({
        url: '/api/blade-sorder/starorder/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

// 选择发布人(下拉框列表)
export const getPublishList = (userId) => {
    return request({
        url: '/api/blade-order/order/getPublishUserList',
        method: 'get',
        params: {
            userId,
        }
    })
}
// 根据当前登录用户部门查询
export const getPublishListByCode = (code) => {
    return request({
        url: '/api/blade-order/order/getDeptListByCode',
        method: 'post',
        data: {
            code,
        }
    })
}

// 根据当前登录用户部门查询
export const getPublishListDept = () => {
    return request({
        url: '/api/blade-order/order/getDeptList',
        method: 'get'
    })
}

// 订单状态-变更
export const updateStatus = (id, status) => {
    return request({
        url: '/api/blade-order/order/updateStatus',
        method: 'post',
        data: {
            id,
            status
        }
    })
}

// 生成初始计划单,提交中心审核(一审)
export const auditPlanHandle = (orderId) => {
    return request({
        url: '/api/blade-sorder/starorder/auditPlan',
        method: 'post',
        data: {
            orderId:orderId
        }
    })
}

// 一审
export const auditOneHandle = (data) => {
    return request({
        url: '/api/blade-sorder/starorder/centerAudit',
        method: 'post',
        data: data
    })
}

// 生成初始计划单,提交中心审核(一审)
export const generatePlanHandle = (orderId) => {
    return request({
        url: '/api/blade-sorder/starorder/generatePlan',
        method: 'post',
        data: {
            orderId:orderId
        }
    })
}


// 根据订单id查询初始计划单列表
export const getOrderinitialplanList = (orderId) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/list/'+orderId,
        method: 'get',
    })
}

// 自动派单(所有计划单全自动)
export const autoPlanHandle = (data) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/autoPlan',
        method: 'post',
        data: data
    })
}

// 计划单,手动指定参与机构(多个计划,须依次指定)
export const allocationHandle = (data) => {
    return request({
        url: '/api/blade-sorder/orderinitialplan/allocation',
        method: 'post',
        data: data
    })
}

// 二审
export const auditTwoHandle = (data) => {
    return request({
        url: '/api/blade-order/order/auditTwo',
        method: 'post',
        data: data
    })
}

// 评分
export const orderEvaluationHandle = (data) => {
    return request({
        url: '/api/blade-sorder/starorder/orderEvaluation',
        method: 'post',
        data: data
    })
}


// 派单记录
export const orderInitialRecordList = (orderId) => {
    return request({
        url: '/api/blade-sorder/starorder/orderInitialRecordList/'+orderId,
        method: 'get',
    })
}

// 手动结案
export const orderManualCase = (orderId) => {
    return request({
        url: '/api/blade-sorder/starorder/manualCase',
        method: 'post',
        data:{
            orderId:orderId
        }
    })
}

// 根据部门id获取部门人员
export const getDeptPeopleByDeptId = (depId) => {
    return request({
        url: '/api/blade-sorder/starorder/dep/'+depId,
        method: 'get',
    })
}


// 区域分流
export const perfectRegional = (data) => {
    return request({
        url: '/api/blade-sorder/starorder/perfectRegional',
        method: 'post',
        data:data
    })
}

// 根据区域code查询部门列表
export const getDeptListByRegionCode = (code) => {
    return request({
        url: '/api/blade-system/dept/region-list',
        method: 'get',
        params:{
            code:code
        }
    })
}
// 查询当前登录用户是否已经评价
export const isOrderEvaluation = (id) => {
    return request({
        url: '/api//blade-sorder/starorder/isOrderEvaluation/'+id,
        method: 'post'
    })
}

// 查询某个身份证号对应人员的订单类型统计
export const personalWorkTypeData = params => {
    // console.log('get提交', params)
    return request({
        url: '/api/blade-stat/home/personalWorkType',
        method: 'get',
        params
    })
  }
// 查询某个身份证号对应人员的具体计划的参与机构统计数据
export const specificPlanData = params => {
    // console.log('get提交', params)
    return request({
        url: '/api/blade-stat/home/specificPlan',
        method: 'get',
        params
    })
  }
// 查询某个订单对应人员的具体计划的参与机构统计数据
export const specificPlanOfOrderData = params => {
    // console.log('get提交', params)
    return request({
        url: '/api/blade-stat/home/specificPlanOfOrder',
        method: 'get',
        params
    })
  }
//查询订单状态-信息
export const getStatusInfo = params => {
    return request({
        url: '/api/blade-system/dict-biz/dictionary?code=order_status',
        method: 'get',
        params
    })
  }